(function () {

  // --- Product embeds ---
  document.querySelectorAll('[data-product-embed]').forEach(function (el) {
    var handle = el.getAttribute('data-product-embed');
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then(function (p) {
        var price = (p.price_min / 100).toFixed(2);
        var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
          ? window.Shopify.currency.active : '';
        var imgHtml = p.featured_image
          ? '<img src="' + p.featured_image + '" alt="' + p.title.replace(/"/g, '&quot;') + '" class="pe-img">'
          : '';

        el.innerHTML =
          '<a href="/products/' + p.handle + '" class="pe-card">' +
          imgHtml +
          '<div class="pe-info">' +
          '<div class="pe-label">Product</div>' +
          '<div class="pe-title">' + p.title + '</div>' +
          '<div class="pe-price">' + price + (currency ? ' ' + currency : '') + '</div>' +
          '</div>' +
          '</a>';
      })
      .catch(function () {});
  });

  // --- Collection embeds ---
  document.querySelectorAll('[data-collection-embed]').forEach(function (el) {
    var handle = el.getAttribute('data-collection-embed');
    if (!handle) return;

    fetch('/search/suggest.json?q=' + encodeURIComponent(handle) + '&resources[type]=collection&resources[limit]=5')
      .then(function (r) {
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then(function (data) {
        var list = (data.resources && data.resources.results && data.resources.results.collections) || [];
        var col = list.find(function (c) { return c.url && c.url.endsWith('/' + handle); }) || list[0];
        if (!col) return;

        var imgHtml = (col.featured_image && col.featured_image.url)
          ? '<img src="' + col.featured_image.url + '" alt="' + col.title.replace(/"/g, '&quot;') + '" class="pe-img">'
          : '';

        el.innerHTML =
          '<a href="' + col.url + '" class="pe-card pe-card--collection">' +
          imgHtml +
          '<div class="pe-info">' +
          '<div class="pe-label">Collection</div>' +
          '<div class="pe-title">' + col.title + '</div>' +
          '<div class="pe-cta">Browse collection →</div>' +
          '</div>' +
          '</a>';
      })
      .catch(function () {});
  });

})();
